module.exports = __webpack_public_path__ + "static/tyrant06-eb331d0bf7e0de31f33c41700a63390c.png";